"use strict";

/* eslint no-console: 0 */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitForm = void 0;

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _enviro = _interopRequireDefault(require("enviro"));

/**
 * @param {String} formUrl
 * @param {Object} data
 * @return {Promise}
 */
var submitForm = function submitForm(formUrl, data) {
  if (_enviro.default.getShort() !== 'prod') {
    console.log('Submission to pql form', formUrl, data);
  }

  return _noAuthApiClient.default.post(formUrl, {
    data: data
  });
};

exports.submitForm = submitForm;